import { locationIdFormat } from "@redotech/redo-inventory-id";
import { InventoryAdjustmentKind } from "@redotech/redo-prisma-client/enums";
import { productIdFormat } from "@redotech/redo-product-id";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const AdjustmentReferenceDataSchema = z.discriminatedUnion("kind", [
  z.object({
    kind: z.literal("cycleCount"),
    cycleCountId: z.string(),
    status: z.string(),
    countedBy: z.string().nullable(),
  }),
  z.object({
    kind: z.literal("adjustmentSession"),
    sessionId: z.string(),
    sessionKind: z.string(),
    submittedBy: z.string().nullable(),
  }),
  z.object({
    kind: z.literal("inboundShipment"),
    shipmentId: z.string(),
    status: z.string(),
    receivedBy: z.string().nullable(),
  }),
  z.object({
    kind: z.literal("fulfillmentGroup"),
    orderId: z.string(),
    orderName: z.string().nullable(),
  }),
  z.object({ kind: z.literal("return"), returnId: z.string() }),
]);

export type AdjustmentReferenceData = z.infer<
  typeof AdjustmentReferenceDataSchema
>;

const AdjustmentHistoryItemSchema_ = z.object({
  id: z.string(),
  kind: createEnum(InventoryAdjustmentKind),
  kindDisplay: z.string(),
  quantityDelta: z.number(),
  committedDelta: z.number(),
  notes: z.string().nullable(),
  referenceId: z.string().nullable(),
  actor: z.string(),
  referenceData: AdjustmentReferenceDataSchema.nullable(),
  createdAt: z.string(),
});

export const AdjustmentHistoryItemSchema: z.ZodType<AdjustmentHistoryItem> =
  AdjustmentHistoryItemSchema_;
export interface AdjustmentHistoryItem extends z.infer<
  typeof AdjustmentHistoryItemSchema_
> {}

export const listAdjustmentHistory = {
  name: "listAdjustmentHistory" as const,
  input: z.object({
    productId: productIdFormat.schema,
    locationId: locationIdFormat.schema,
    sortDirection: createEnum(["asc", "desc"]).default("desc"),
    limit: z.number().default(50),
    offset: z.number().default(0),
  }),
  output: z.object({
    items: z.array(AdjustmentHistoryItemSchema),
    total: z.number(),
  }),
};
